import React from 'react'
import styled from 'styled-components'
import FinanceStatusBadge from '../FinanceStatusBadge'
import { financeColors, financeRadius } from '../tokens'
import { FinanceChecklistItem } from '../types'

interface Props {
  items: FinanceChecklistItem[]
}

const Wrap = styled.div`
  display: grid;
  gap: 10px;
  margin-top: 16px;
`

const Row = styled.div<{ $complete: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: ${financeRadius.sm};
  border: 1px solid
    ${(props) =>
      props.$complete
        ? financeColors.successBorder
        : financeColors.warningBorder};
  background: ${(props) =>
    props.$complete ? financeColors.successBg : financeColors.warningBg};
`

const Label = styled.div`
  font-size: 14px;
  color: #1f2937;
`

const Action = styled.button`
  border: 0;
  background: transparent;
  color: #166534;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  padding: 0;
`

const FinanceChecklist: React.FC<Props> = ({ items }) => (
  <Wrap>
    {items.map((item, index) => (
      <Row key={`${index}-${String(item.label)}`} $complete={item.complete}>
        <Label>{item.label}</Label>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <FinanceStatusBadge status={item.complete ? 'active' : 'draft'} />
          {item.onAction && (
            <Action type="button" onClick={item.onAction}>
              {item.actionLabel || 'Open'}
            </Action>
          )}
        </div>
      </Row>
    ))}
  </Wrap>
)

export default FinanceChecklist
